import { Injectable } from '@angular/core';
import * as objectPath from 'object-path';
import { BehaviorSubject } from 'rxjs';
import { MenuConfigService } from './menu-config.service';

@Injectable()
export class MenuAsideService {
  menuList$: BehaviorSubject<[]> = new BehaviorSubject([]);
  product$: BehaviorSubject<string> = new BehaviorSubject('');
  constructor(private menuConfigService: MenuConfigService) {
    this.menuConfigService.onMenuUpdated$.subscribe((model) => {
      setTimeout(() => {
        this.menuList$.next(objectPath.get(model.config, 'aside.items'));
        this.product$.next(objectPath.get(model.config, 'product'));
      });
    });
  }
}
